import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeslotFormat',
  standalone: true,
})
export class TimeSlotFormatPipe implements PipeTransform {
  transform(value: string | undefined): unknown {
    if (!value) return '';

    return Intl.DateTimeFormat('en-GB', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(new Date(value));
  }
}
